module.exports = __webpack_public_path__ + "static/media/geld.d35aaf1c.jpg";